// extracted by mini-css-extract-plugin
export default {"infoMsg":"styles_infoMsg__FrWi9","noData":"styles_noData__tZs6r","noData__mobile":"styles_noData__mobile__dMHhl"};